var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mdRef",staticClass:"wrapper",class:{ 'math-anim-isolated-wrapper': !_vm.plain }})
}
var staticRenderFns = []

export { render, staticRenderFns }